import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl';
import { useDispatch } from "react-redux";

import ViewTableInformation from '../../../Common/TableRecords/ViewTableInformation';
import ViewTableBodyInformation from '../../../Common/TableRecords/ViewTableBodyInformation';
import { RenterOwnerDetailsIcon } from '../../../../components/Common/Assets/SvgIconComponent/SideMenuIcons';
import { censorPhone, censorEmail, decode } from '../../../../helpers/secureEmail';
import { demoRestrictionEncode } from '../../../../helpers/DemoRestriction/demoRestriction';
import messages from '../../../../locale/jsonMessages';

const RenterOwnerDetails = ({ data }) => {
    const { formatMessage } = useIntl();
    const [isRestrict, setRestrict] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        async function fetchData() {
            const isDemoRestrict = await dispatch(demoRestrictionEncode());
            setRestrict(isDemoRestrict);
        }
        fetchData();
    }, []);

    let guestName, hostName;
    if (data?.guestData) guestName = data?.guestData?.firstName + " " + data?.guestData?.lastName;
    if (data?.hostData) hostName = data?.hostData?.firstName + " " + data?.hostData?.lastName;
    return (
        <div>
            <ViewTableInformation title={formatMessage(messages.renterAndOwnerDetails)} icon={<RenterOwnerDetailsIcon />}>
                {data?.guestData?.profileId && <ViewTableBodyInformation
                    title={formatMessage(messages.renterName)}
                    linkText={guestName}
                    linkData={"/users/show/" + data?.guestData?.profileId}
                />}
                {data?.guestUser?.encryptEmail && <ViewTableBodyInformation
                    title={formatMessage(messages.renterEmail)}
                    value={!isRestrict ? decode(data?.guestUser?.encryptEmail) : censorEmail(decode(data?.guestUser?.encryptEmail))}
                />}
                {data?.guestData?.phoneNumber && <ViewTableBodyInformation
                    title={formatMessage(messages.renterPhoneNumber)}
                    value={data?.guestData?.countryCode + " " + (!isRestrict ? decode(data?.guestData?.phoneNumber) : censorPhone(decode(data?.guestData?.phoneNumber)))}
                />}
                {data?.hostData?.profileId && <ViewTableBodyInformation
                    title={formatMessage(messages.ownersName)}
                    linkText={hostName}
                    linkData={"/users/show/" + data?.hostData?.profileId}
                />}
                {data?.hostUser?.encryptEmail && <ViewTableBodyInformation
                    title={formatMessage(messages.ownerEmailLabel)}
                    value={!isRestrict ? decode(data?.hostUser?.encryptEmail) : censorEmail(decode(data?.hostUser?.encryptEmail))}
                />}
                {data?.hostData?.phoneNumber && <ViewTableBodyInformation
                    title={formatMessage(messages.ownerPhoneNumber)}
                    value={data?.hostData?.countryCode + " " + (!isRestrict ? decode(data?.hostData?.phoneNumber) : censorPhone(decode(data?.hostData?.phoneNumber)))}
                />}
            </ViewTableInformation>
        </div>
    )
}

export default RenterOwnerDetails;

